// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideParentheses as RawLucideParentheses } from "lucide-react";
export const LucideParentheses = /* @__PURE__ */ createIcon(RawLucideParentheses, "LucideParentheses", 2);
